import { ODataReadInfiniteOptions } from '@msrceng/component';
import { Acknowledgement } from '../../types';
import { useAcknowledgementInfiniteApi } from './useAcknowledgementInfiniteApi';

/** Get an infinitely growing list of Affected Product items filtered by CVE number */

export const useAcknowledgementInfiniteApiFromCveNumber = (
  cveNumber?: string,
  options?: ODataReadInfiniteOptions<Acknowledgement>
) =>
  useAcknowledgementInfiniteApi(
    {
      filter: cveNumber
        ? {
            cveNumber: {
              data: `'${cveNumber}'`,
              operator: 'eq',
            },
          }
        : undefined,
    },
    options
  );
